class Main extends React.Component {
    render() {
        return (
          	<div></div>
        );
    }
}

export default Main;


// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-table-edit/index.js